import * as React from 'react';

interface ModalProps {
  title: string;
  isActive: boolean;
  onDismiss: () => void;
  onModalAction: (() => void) | undefined;
  modalActionClass: string;
  modalActionText: string;
}

export default class Modal extends React.PureComponent<ModalProps, {}> {
  dismiss = (e: React.MouseEvent<HTMLDivElement | HTMLButtonElement>) => {
    e.stopPropagation();
    this.props.onDismiss();
  };

  render(): JSX.Element {
    return (
      <div className={`modal ${this.props.isActive ? 'is-active' : ''}`}>
        <div className="modal-background" onClick={this.dismiss} />
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">{this.props.title}</p>
            <button className="delete" onClick={this.dismiss} />
          </header>
          <section className="modal-card-body">{this.props.children}</section>
          <footer className="modal-card-foot">
            <button className={`button ${this.props.modalActionClass || ''}`} onClick={this.props.onModalAction}>
              {this.props.modalActionText}
            </button>
          </footer>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/modal.tsx